/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFolders.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Folder Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, November 19, 2018 - 06:07:58 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      11/19/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const FOLDER_LIST_CONTAINER_LOADED = 'FOLDER_LIST_CONTAINER_LOADED';
export const FOLDER_LIST_CONTAINER_UNLOADED = 'FOLDER_LIST_CONTAINER_UNLOADED';
export const FOLDER_LIST_TABLE_LOADED = 'FOLDER_LIST_TABLE_LOADED';
export const FOLDER_LIST_TABLE_UNLOADED = 'FOLDER_LIST_TABLE_UNLOADED';

export const FOLDER_LIST_CHANGE_GROUP = 'FOLDER_LIST_CHANGE_GROUP';
export const FOLDER_SELECT_ROW = 'FOLDER_SELECT_ROW';

export const FOLDER_ADD = 'FOLDER_ADD';
export const FOLDER_EDIT = 'FOLDER_EDIT';
export const FOLDER_DELETE = 'FOLDER_DELETE';
export const FOLDER_OPEN_WARNING = 'FOLDER_OPEN_WARNING';
export const FOLDER_CLOSE_WARNING = 'FOLDER_CLOSE_WARNING';
export const FOLDER_DELETE_DISABLE = 'FOLDER_DELETE_DISABLE';
export const FOLDER_VIEW_CHILD_ITEMS = 'FOLDER_VIEW_CHILD_ITEMS';

export const FOLDER_OPEN_FOLDER = 'FOLDER_OPEN_FOLDER';
export const FOLDER_CLOSE_FOLDER = 'FOLDER_CLOSE_FOLDER';
export const FOLDER_SELECT_FOLDER = 'FOLDER_SELECT_FOLDER';
export const FOLDER_OPEN_FOLDER_WARN = 'FOLDER_OPEN_FOLDER_WARN';
export const FOLDER_CLOSE_FOLDER_WARN = 'FOLDER_CLOSE_FOLDER_WARN';
export const FOLDER_FOLDER_LOAD = 'FOLDER_FOLDER_LOAD';

export const FOLDER_OPEN_DOCUMENT = 'FOLDER_OPEN_DOCUMENT';
export const FOLDER_CLOSE_DOCUMENT = 'FOLDER_CLOSE_DOCUMENT';
export const FOLDER_SELECT_DOCUMENT = 'FOLDER_SELECT_DOCUMENT';
export const FOLDER_OPEN_DOCUMENT_WARN = 'FOLDER_OPEN_DOCUMENT_WARN';
export const FOLDER_CLOSE_DOCUMENT_WARN = 'FOLDER_CLOSE_DOCUMENT_WARN';
export const FOLDER_DOCUMENT_LOAD = 'FOLDER_DOCUMENT_LOAD';

export const FOLDER_OPEN_FILE = 'FOLDER_OPEN_FILE';
export const FOLDER_CLOSE_FILE = 'FOLDER_CLOSE_FILE';
export const FOLDER_SELECT_FILE = 'FOLDER_SELECT_FILE';
export const FOLDER_OPEN_FILE_WARN = 'FOLDER_OPEN_FILE_WARN';
export const FOLDER_CLOSE_FILE_WARN = 'FOLDER_CLOSE_FILE_WARN';
export const FOLDER_FILE_LOAD = 'FOLDER_FILE_LOAD';

export const FOLDER_OPEN_IMAGE = 'FOLDER_OPEN_IMAGE';
export const FOLDER_CLOSE_IMAGE = 'FOLDER_CLOSE_IMAGE';
export const FOLDER_SELECT_IMAGE = 'FOLDER_SELECT_IMAGE';
export const FOLDER_OPEN_IMAGE_WARN = 'FOLDER_OPEN_IMAGE_WARN';
export const FOLDER_CLOSE_IMAGE_WARN = 'FOLDER_CLOSE_IMAGE_WARN';
export const FOLDER_IMAGE_LOAD = 'FOLDER_IMAGE_LOAD';

export const FOLDER_UPDATE_FIELD = 'FOLDER_UPDATE_FIELD';
export const FOLDER_UPDATE_FILE = 'FOLDER_UPDATE_FILE';

export const FOLDER_EDIT_CONTAINER_LOADED = 'FOLDER_EDIT_CONTAINER_LOADED';
export const FOLDER_EDIT_CONTAINER_UNLOADED = 'FOLDER_EDIT_CONTAINER_UNLOADED';
export const FOLDER_EDIT_FORM_LOADED = 'FOLDER_EDIT_FORM_LOADED';
export const FOLDER_EDIT_FORM_UNLOADED = 'FOLDER_EDIT_FORM_UNLOADED';

export const FOLDER_SET_GROUP_SELECT = 'FOLDER_SET_GROUP_SELECT';
export const FOLDER_EDIT_DATA_LOAD = 'FOLDER_EDIT_DATA_LOAD';

export const FOLDER_EDIT_CONTAINER_SUBMIT = 'FOLDER_EDIT_CONTAINER_SUBMIT';
export const FOLDER_EDIT_CONTAINER_CANCEL = 'FOLDER_EDIT_CONTAINER_CANCEL';

export const FOLDER_CONTENTS_LOADED = 'FOLDER_CONTENTS_LOADED';
export const UPDATE_FOLDERID = 'UPDATE_FOLDERID';